<ion-card class="card-common-blue ion-no-margin ion-margin-top">
  <!-- Card header with title and icon -->
  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <ion-icon size="small" src="assets/imgs/calendar-icon-white.svg">
        </ion-icon>

        <span>
          {{ 'APP_MSG' | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <!-- Card content -->
  <ion-card-content class="ion-no-padding">
    <!-- Web view layout -->
    @if (!isMobileApp()) {
    @if (openAppointments().length > 0) {
    <ion-grid class="commonGrid ion-margin">
      <!-- Grid header -->
      <ion-row class="gridHead">
        <ion-col size="2">
          {{ 'D_LABEL13' | translate }}
        </ion-col>
        <ion-col size="10">
          {{ 'PRE_USE_LABEL22' | translate }}
        </ion-col>
      </ion-row>

      <!-- Grid data rows -->
      @for (appointment of openAppointments(); track $index) {
      <ion-row class="gridData">
        <ion-col size="2">
          {{ appointment.bookingDate | formatDate:isMobileApp() }}
        </ion-col>

        <ion-col size="10">
          {{ appointment.ataBookingDescription || 'Maintenance' }}
        </ion-col>
      </ion-row>
      }
    </ion-grid>
    }
    @else {
    <ng-container>
      <ng-template [ngTemplateOutlet]="noAppointmentsRef"></ng-template>
    </ng-container>
    }
    }

    <!-- Mobile view layout -->
    @else {
    @if (openAppointments().length > 0) {
    @for (appointment of openAppointments(); let i = $index; track $index) {
    <ion-item-divider class="bg-transparent ion-no-padding"
      [class.no-border-bottom]="openAppointments().length > 0 && i === openAppointments().length - 1">
      <ion-item lines="none" class="openApplication-mobile w-100">
        <ion-label class="primary-color ion-no-margin ion-margin-top">
          <!-- Booking date -->
          <ion-text class="bookingDate">
            {{ appointment.bookingDate | formatDate:isMobileApp() }}
          </ion-text>

          <!-- Concern details -->
          <ion-item lines="none" class="ion-no-padding primary-color fw-normal concerns">
            <div class="concern-row">
              <ion-text class="concern-label">
                {{ 'RB_CONCERN' | translate }} <span>:</span>
              </ion-text>

              <ion-text class="concern-value">
                {{ appointment.ataBookingDescription || 'Maintenance' }}
              </ion-text>
            </div>
          </ion-item>
        </ion-label>
      </ion-item>
    </ion-item-divider>
    }
    }
    @else {
    <ng-container>
      <ng-template [ngTemplateOutlet]="noAppointmentsRef"></ng-template>
    </ng-container>
    }
    }
  </ion-card-content>
</ion-card>

<!-- Empty state template -->
<ng-template #noAppointmentsRef>
  <ion-row class="ion-margin">
    <ion-col size="12" class="d-flex justify-content-center">
      {{ 'OPEN_APPOINTMENT_VALIDATION' | translate }}
    </ion-col>
  </ion-row>
</ng-template>